/*
 * @Description:
 * @Author: rqcheng
 * @Date: 2025-06-20 14:53:40
 * @LastEditors: rqcheng
 * @LastEditTime: 2025-06-20 14:54:31
 */
/**
 * @description 网络配置
 */
export const baseURL = "/api";
export const mpURL = "/mp";
export const imageBaseURL = "https://www.nmgnq.cn";
export const weatherURL = "/weather-api";

// 配置contentType
export const contentType = "application/json;charset=UTF-8";
// message持续时间
export const messageDuration = 3000;
//超时时间
export const requestTimeout = 60000;
// 请求正常code
export const successCode = [200];
// 登录过期code
export const invalidCode = 401;
//  无权限code
export const forbiddenCode = 403;
// 重复请求code
export const REPEAT_CODE = 433;



// WEBPACK FOOTER //
// ./src/config/network.js